import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateDayApi } from "../../../../api/day";
import { getAccessToken } from "../../../../api/auth";

import "./EditDayForm.scss";

export default function EditDayForm(props) {
  const { day, setIsVisibleModal, setReloadDays } = props;
  const [dayData, setDayData] = useState({});

  //trae los datos de dia
  useEffect(() => {
    setDayData({
      day_code: day.day_code,
      description: day.description,
    });
  }, [day]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!dayData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateDay = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let dayUpdate = dayData; //es let porque se va actualizando

      updateDayApi(token, dayUpdate, day._id).then((result) => {
        if (
          result.message === "ERR_CONNECTION_REFUSED" ||
          result.message === "Failed to fetch" ||
          result.message === undefined
        ) {
          notification["error"]({
            message: "Servidor caido",
          });
          setIsVisibleModal(true);
        } else if (result.code !== 200) {
          notification["error"]({
            message: result.message,
          });
          setIsVisibleModal(true);
        } else {
          notification["success"]({
            message: result.message, //el mensaje que viene del server
          });
          //console.log("respuesta: " + result.message);
          setIsVisibleModal(false);
          setReloadDays(true);
        }
      });
    }
  };

  return (
    <div className="edit-day-form">
      <EditForm
        dayData={dayData}
        setDayData={setDayData}
        updateDay={updateDay}
      />
    </div>
  );
}

function EditForm(props) {
  const { dayData, setDayData, updateDay } = props;

  return (
    <Form className="form-edit" onSubmit={updateDay}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={dayData.day_code}
              onChange={(e) => setDayData({ ...dayData, day_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripción"
              value={dayData.description}
              onChange={(e) =>
                setDayData({ ...dayData, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateDay}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
